import React from "react";
import {useQuery} from "@apollo/client";
import {window} from "window-or-global";
import PortalHeader from "../components/portal/portal-header";
import Main from "../components/main";
import Loader from "../components/bootstrap/loader";
import MfaComponent from "../components/mfa";
import {getCurrentUserQuery} from "../components/logic/user";

export default function Mfa() {
  return (
    <Main>
      <PortalHeader />
      <MfaIndex/>
    </Main>
  );
}


const MfaIndex = () => {
  const currentUserQuery = useQuery(getCurrentUserQuery);
  if (currentUserQuery.loading) {
    return <Loader />;
  }

  const user = currentUserQuery?.data?.classMethods?.User?.getCurrentUser;

  if (!user) {
    window.location.href = "/login";
  }

  return <MfaComponent user={user} userQueryRefetch={currentUserQuery?.refetch}/>
};
